/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_Sports_And_Fitness16Inputs */

const en_job_form_enum_sports_and_fitness16 = /** @type {(inputs: Job_Form_Enum_Sports_And_Fitness16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sports and Fitness`)
};

const de_job_form_enum_sports_and_fitness16 = /** @type {(inputs: Job_Form_Enum_Sports_And_Fitness16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sport und Fitness`)
};

/**
* | output |
* | --- |
* | "Sports and Fitness" |
*
* @param {Job_Form_Enum_Sports_And_Fitness16Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_sports_and_fitness16 = /** @type {((inputs?: Job_Form_Enum_Sports_And_Fitness16Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_Sports_And_Fitness16Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_sports_and_fitness16(inputs)
	return en_job_form_enum_sports_and_fitness16(inputs)
});
export { job_form_enum_sports_and_fitness16 as "job_form_enum_SPORTS_AND_FITNESS" }